import { FaArrowRight, FaMapMarkerAlt, FaSlash, FaDrawPolygon, FaRegCircle, FaRegSquare } from 'react-icons/fa';
const BioDiversityItemView = ({ item, handleItemHighlight, handleItemView }) => {
    return (
        <tr>
            <td style={{width:"5%"}}>
                <a onMouseOver={(itemId) => handleItemHighlight(item.itemId)} onMouseOut={(itemId) => handleItemHighlight(0)}>
                        {item.mapMarkerType == 'marker' ? <FaMapMarkerAlt color={item.colour}></FaMapMarkerAlt> :
                            item.mapMarkerType == 'polyline' ? <FaSlash color={item.colour}></FaSlash> :
                                item.mapMarkerType == 'polygon' ? <FaDrawPolygon color={item.colour}></FaDrawPolygon> :
                                    item.mapMarkerType == 'circle' ? <FaRegCircle color={item.colour}></FaRegCircle> :
                                        item.mapMarkerType == 'rectangle' && <FaRegSquare color={item.colour}></FaRegSquare>}
                    </a>
                </td>
            <td style={{ width: "20%" }}>{item.name} </td>
            <td style={{ width: "20%" }}>{item.itemTypeName} </td>
            <td style={{ width: "50%",fontSize:"13px" }}>{item.bioDiversityComment} </td>
            <td style={{ width: "5%" }}>
                <button type="button" id={"view" + item.itemId}
                    onClick={(itemId, routePath) => handleItemView(item.itemId, item.routePath)}
                    className="btn btn-primary btn-sm">
                    View
                </button>
                </td>
            </tr>
        )
}
export default BioDiversityItemView;